module.exports = __webpack_public_path__ + "img/img_nav_detail_hover.450c4cc0.svg";